import React from 'react';
import {Button as MuiButton, ButtonProps} from '@mui/material';

const Button = (props: ButtonProps) => (
   <MuiButton variant="contained" size="small" type="button" color="secondary" {...props} />
);

export default Button;
